<template>
    <span>
        <span v-if="isFilled == 'true'" class="base-box-icons box-filled">
            <img src="@assets/box-icons/filled-box.png" />
        </span>
        <span v-else-if="isFilled == 'false'" class="base-box-icons box">
            <img src="@/assets/box-icons/box.png" />
        </span>
        <span v-else></span>
    </span>
</template>

<script>
export default {
    props: {
        isFilled: String,
    }
}
</script>